'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.inView = twentyninetimes.inView || function () {

	function init(scroll_items) {
		if ( scroll_items ) {
			scroll_items.forEach(item => {
			    makeWatcher(item);
			});
		}
	}

    function viewportWatcher() {
    	let item = this.watchItem;
    	
    	if ( !this.isInViewport ) {
    		if ( item.classList.contains('in-view') )
    			item.classList.remove('in-view');

    		return;
    	} else {

    		if ( !item.classList.contains('in-view') )
    			item.classList.add('in-view');

    		if ( item.classList.contains('js-lazy-load') )
    			setImgSrc(item);
    	}
    }

    function setImgSrc(item) {
    	if ( !item.classList.contains('img-loaded') ) {
    		var img 	= item.getElementsByTagName('img')[0],
    			img_src = img.getAttribute('data-src');

	    	img.src = img_src;

	    	img.addEventListener('load', function() {
	    		item.classList.add('img-loaded');
	    		item.classList.remove('js-lazy-load');
	    	});
    	}
    }

    function makeWatcher( item ) {
    	var item_height = item.offsetHeight / 2,
    		watcher = scrollMonitor.create( item, 0 );
    	watcher.stateChange(viewportWatcher);
    	viewportWatcher.call( watcher );
    }

	return {
		init : init
	};

}();